import { flexRender } from "@tanstack/react-table"
import { ChevronDown, ChevronUp, ChevronsUpDown } from 'lucide-react';
import { TableHeader, TableRow, TableHead, cn, Checkbox } from 'twyne-new.ui';

import ColumnResizer from "@/components/DefaultTableResize_/ColumnResizer";
import { getColumnWidthStyle, ROW_SELECTION_COLUMN_WIDTH } from "@/components/tableResize/helper";
import { useGrid } from '@Components/Grid/context';

import { toggleFormatter } from "../../utils/column";

import { useTableContext } from "./context"

export default function DefaultTableHeader() {
  const table = useTableContext()
  const headerGroups = table.getHeaderGroups()
  return <TableHeader sticky>
    {headerGroups.map(({ id, headers }) => <TableRow key={id}>
      {/* <HeaderCheckbox table={table} /> */}
      {headers.map(header => {
        const { id, column, isPlaceholder, getContext } = header

        return <Column
          key={id}
          isPlaceholder={isPlaceholder}
          header={column.columnDef.header}
          canSort={column.getCanSort()}
          onSort={column.getToggleSortingHandler()}
          isSorted={column.getIsSorted()}
          context={getContext()}
          headerItem={header}
        />
      })}
    </TableRow>)
    }
  </TableHeader>
}

function HeaderCheckbox({ table }) {
  const { rows } = table.getRowModel()
  const rowIds = rows.map(({ id, original }) => `${original?.id ?? id}`)
  const { rowsSelected, setRowsSelected } = useGrid()
  const allRowsSelected = rowIds.length > 0 && rowIds.every(id => rowsSelected.includes(id))

  const handleSelectAll = checkedValue => {
    const checked = typeof checkedValue === 'boolean' ? checkedValue : !!checkedValue?.target?.checked

    if (checked) {
      setRowsSelected(prevRowsSelected => Array.from(new Set([...prevRowsSelected, ...rowIds])))
      return
    }

    setRowsSelected([])
  }

  return <TableHead style={{ width: ROW_SELECTION_COLUMN_WIDTH, maxWidth: ROW_SELECTION_COLUMN_WIDTH }}>
    <Checkbox value={allRowsSelected} onChange={handleSelectAll} />
  </TableHead>
}

function TableHeaderSort({ order, canSort }) {
  if (!canSort) {
    return null
  }

  const Icon = {
    asc: ChevronUp,
    desc: ChevronDown,
    default: ChevronsUpDown,
  }[order || 'default']

  return <Icon size={10} className='twy-text-base-neutral hover:twy-text-base-accent' />
}

function Column({ header, headerItem, isPlaceholder, context, canSort, onSort, isSorted }) {
  if (isPlaceholder) {
    return null
  }

  return <ColumnHeader headerItem={headerItem} onClick={onSort} isSorted={isSorted} canSort={canSort}>
    {flexRender(header, context)}
  </ColumnHeader>
}

function ColumnHeader({ headerItem, children, onClick, isSorted, canSort }) {
  const { definitions: { enableTableResize = true } } = useGrid()
  const { enableColumnResize = true, className } = headerItem.column.columnDef
  const isToggle = headerItem.column.columnDef.cell === toggleFormatter

  return <TableHead
    className={cn('relative group', className)}
    key={headerItem.id}
    colSpan={headerItem.colSpan}
    style={getColumnWidthStyle({ resizable: enableTableResize, id: headerItem.column.id, size: headerItem.column.columnDef.size, maxSize: headerItem.column.columnDef.maxSize })}
  >
    <ColumnResizer
      header={headerItem}
      canResize={enableTableResize && enableColumnResize && !isToggle}
      tableContext={useTableContext}
    />
    <div onClick={onClick} className={cn('flex gap-1 items-center mr-4', canSort ? 'cursor-pointer' : '', className)}>
      {children} <TableHeaderSort order={isSorted} canSort={canSort} />
    </div>
  </TableHead>
}
